<div class="overflow-container">
  <!-- Visible items as tags -->
  @if (useTags) {
    <span class="visible-items">
      @for (item of visibleItems; track item) {
        <mc-tag class="tag-item" appearance="neutral-weak" fit="small" padding="compact" [label]="item"> </mc-tag>
      }
    </span>
  } @else {
    <!-- Visible items as plain text -->
    <span class="visible-items">
      @for (item of visibleItems; track item; let last = $last) {
        <span>
          {{ item }}
          @if (!last) {
            <span>, </span>
          }
        </span>
      }
    </span>
  }

  @if (remainingCount > 0) {
    <mc-popover position="bottom-left" maxwidth="280px" minwidth="200px" maxheight="300px">
      <!-- Trigger -->
      <span slot="trigger" class="more-count"> +{{ remainingCount }} </span>

      <!-- Popover content -->
      <div class="popover-content">
        @if (useTags) {
          <div class="tag-grid">
            @for (item of hiddenItems; track item) {
              <div>
                <mc-tag appearance="neutral-weak" fit="small" padding="compact" [label]="item"> </mc-tag>
              </div>
            }
          </div>
        } @else {
          @for (item of hiddenItems; track item) {
            <div>
              {{ item }}
            </div>
          }
        }
      </div>
    </mc-popover>
  }
</div>
